export const products = [
  // Royal honey V
  {
    name: 'Royal honey V',
    caption: 'お試し用（10g x 6袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+vip+%E3%81%8A%E8%A9%A6%E3%81%97%E7%94%A8+%EF%BC%8810g%C3%976%E8%A2%8B%EF%BC%89/Royal+honey+vip+%E3%81%8A%E8%A9%A6%E3%81%97%E7%94%A8+%EF%BC%8810g%C3%976%E8%A2%8B%EF%BC%89.png',
    price: 4980,
    // id for rooter-path
    id: 'royal-honey-vip-otameshi'
  },
  {
    name: 'Royal honey V',
    caption: '1箱（10g x 12袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/Royal+honey+vip+1%E7%AE%B1%EF%BC%8810g%C3%9712%E8%A2%8B%EF%BC%89.png',
    price: 9480,
    pricePerBox: 9480,
    id: 'royal-honey-vip-1'
  },
  {
    name: 'Royal honey V',
    caption: '2箱（10g x 24袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+vip+1%E7%AE%B1%EF%BC%8810g%C3%9712%E8%A2%8B%EF%BC%89/royal-honey-vip2.png',

    price: 17960,
    pricePerBox: 8990,
    discount: 1000,
    id: 'royal-honey-vip-2'
  },
  {
    name: 'Royal honey V',
    caption: '5箱（10g x 60袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+vip+1%E7%AE%B1%EF%BC%8810g%C3%9712%E8%A2%8B%EF%BC%89/royal-honey-vip5.png',

    price: 42400,
    pricePerBox: 8480,
    discount: 5000,
    id: 'royal-honey-vip-5'
  },
  {
    name: 'Royal honey V',
    caption: '10箱（10g x 120袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+vip+1%E7%AE%B1%EF%BC%8810g%C3%9712%E8%A2%8B%EF%BC%89/royal-honey-vip10.png',

    price: 79800,
    pricePerBox: 7980,
    discount: 15000,
    id: 'royal-honey-vip-10'
  },
  // Royal honey for him
  {
    name: 'Royal honey',
    caption: '1箱（20g x 12袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+for+him+(20g%C3%9712%E8%A2%8B)/Royal+honey+for+him+(20g%C3%9712%E8%A2%8B).png',

    price: 6980,
    pricePerBox: 6980,
    id: 'royal-honey-for-him'
  },
  {
    name: 'Royal honey',
    caption: '2箱（20g x 24袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+for+him+(20g%C3%9712%E8%A2%8B)/royal-for-him2.png',

    price: 13360,
    pricePerBox: 6680,
    discount: 600,
    id: 'royal-honey-for-him-2'
  },
  {
    name: 'Royal honey',
    caption: '5箱（20g x 60袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+for+him+(20g%C3%9712%E8%A2%8B)/royal-for-him5.png',

    price: 29900,
    pricePerBox: 5980,
    discount: 5000,
    id: 'royal-honey-for-him-5'
  },
  {
    name: 'Royal honey',
    caption: '10箱（20g x 120袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+for+him+(20g%C3%9712%E8%A2%8B)/royal-for-him10.png',

    price: 54800,
    pricePerBox: 5480,
    discount: 15000,
    id: 'royal-honey-for-him-10'
  },
  // Royal honey for her
  {
    name: 'Royal honey for her',
    caption: '1箱（20g x 12袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+for+her+(20g%C3%9712%E8%A2%8B)/Royal+honey+for+her+(20g%C3%9712%E8%A2%8B).png',

    price: 6980,
    pricePerBox: 6980,
    id: 'royal-honey-for-her'
  },
  {
    name: 'Royal honey for her',
    caption: '2箱（20g x 24袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+for+her+(20g%C3%9712%E8%A2%8B)/royal-honey-for-her2.png',

    price: 13360,
    pricePerBox: 6680,
    discount: 600,
    id: 'royal-honey-for-her-2'
  },
  {
    name: 'Royal honey for her',
    caption: '5箱（20g x 60袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+for+her+(20g%C3%9712%E8%A2%8B)/royal-for-her-5.png',

    price: 29900,
    pricePerBox: 5980,
    discount: 5000,
    id: 'royal-honey-for-her-5'
  },
  {
    name: 'Royal honey for her',
    caption: '10箱（20g x 120袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+for+her+(20g%C3%9712%E8%A2%8B)/royal-for-her-10.png',

    price: 54800,
    pricePerBox: 5480,
    discount: 15000,
    id: 'royal-honey-for-her-10'
  },
  // Royal honey power52
  {
    name: 'Royal honey power',
    caption: '1箱（10g x 24袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+power52+(10g%C3%9724%E8%A2%8B)/Royal+honey+power52+(10g%C3%9724%E8%A2%8B).png',

    price: 12700,
    pricePerBox: 12700,
    id: 'royal-honey-power52'
  },
  {
    name: 'Royal honey power',
    caption: '2箱（10g x 48袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+power52+(10g%C3%9724%E8%A2%8B)/royal-power-52-2.png',

    price: 23960,
    pricePerBox: 11980,
    discount: 1440,
    id: 'royal-honey-power52-2'
  },
  {
    name: 'Royal honey power',
    caption: '5箱（10g x 120袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+power52+(10g%C3%9724%E8%A2%8B)/royal-power-52-5.png',

    price: 57400,
    pricePerBox: 11480,
    discount: 6100,
    id: 'royal-honey-power52-5'
  },
  {
    name: 'Royal honey power',
    caption: '10箱（10g x 240袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+power52+(10g%C3%9724%E8%A2%8B)/royal-power-52-10.png',

    price: 109800,
    pricePerBox: 10980,
    discount: 17200,
    id: 'royal-honey-power52-10'
  },
  // Royal honey カップルセット
  {
    name: 'Royal honey カップルセット',
    caption: '(Royal honey V & Royal honey for her)',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/Royal+honey+%E3%82%AB%E3%83%83%E3%83%95%E3%82%9A%E3%83%AB%E3%82%BB%E3%83%83%E3%83%88/Royal+honey+%E3%82%AB%E3%83%83%E3%83%95%E3%82%9A%E3%83%AB%E3%82%BB%E3%83%83%E3%83%88.png',
    price: 16460,
    id: 'royal-honey-kappuru-setto'
  },
  // Tongkat Ali Power Plus
  {
    name: 'TK Power Plus',
    caption: '1箱（10錠）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/tongkat+ali+power+plus/tongkat+ali+power+plus+1.png',
    price: 6980,
    pricePerBox: 6980,
    id: 'tongkat-ali-power-plus-1'
  },
  {
    name: 'TK Power Plus',
    caption: '2箱（20錠）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/tongkat+ali+power+plus/tongkat+ali+power+plus+2.png',
    price: 13360,
    pricePerBox: 6680,
    discount: 600,
    id: 'tongkat-ali-power-plus-2'
  },
  {
    name: 'TK Power Plus',
    caption: '5箱（50錠）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/tongkat+ali+power+plus/tongkat+ali+power+plus+5.png',
    price: 29900,
    pricePerBox: 5980,
    discount: 5000,
    id: 'tongkat-ali-power-plus-5'
  },
  {
    name: 'TK Power Plus',
    caption: '10箱（100錠）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/tongkat+ali+power+plus/tongkat+ali+power+plus+10.png',
    price: 54800,
    pricePerBox: 15000,
    discount: 5480,
    id: 'tongkat-ali-power-plus-10'
  },
  // Royal honey VITAL
  {
    name: 'Royal honey VITAL',
    caption: '1箱（15g x 12袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/royal+honey+vital/royal+honey+vital+1.png',
    price: 7480,
    pricePerBox: 7480,
    id: 'royal-honey-vital-1'
  },
  {
    name: 'Royal honey VITAL',
    caption: '2箱（15g x 24袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/royal+honey+vital/royal+honey+vital+2.png',
    price: 13960,
    pricePerBox: 6980,
    discount: 1000,
    id: 'royal-honey-vital-2'
  },
  {
    name: 'Royal honey VITAL',
    caption: '5箱（15g x 60袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/royal+honey+vital/royal+honey+vital+5.png',
    price: 32400,
    pricePerBox: 6480,
    discount: 5000,
    id: 'royal-honey-vital-5'
  },
  {
    name: 'Royal honey VITAL',
    caption: '10箱（15g x 120袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/royal+honey+vital/royal+honey+vital+10.png',
    price: 59800,
    pricePerBox: 5980,
    discount: 15000,
    id: 'royal-honey-vital-10'
  },
  // Royal honey V PLUS
  {
    name: 'Royal honey V PLUS',
    caption: '1箱（10g x 12袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/royal+honey+vip+plus/royal+honey+vip+plus+1.png',
    price: 12480,
    pricePerBox: 12480,
    id: 'royal-honey-vip-plus-1'
  },
  {
    name: 'Royal honey V PLUS',
    caption: '2箱（10g x 24袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/royal+honey+vip+plus/royal+honey+vip+plus+2.png',
    price: 23960,
    pricePerBox: 11980,
    discount: 1000,
    id: 'royal-honey-vip-plus-2'
  },
  {
    name: 'Royal honey V PLUS',
    caption: '5箱（10g x 60袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/royal+honey+vip+plus/royal+honey+vip+plus+5.png',
    price: 57400,
    pricePerBox: 11480,
    discount: 5000,
    id: 'royal-honey-vip-plus-5'
  },
  {
    name: 'Royal honey V PLUS',
    caption: '10箱（10g x 120袋）',
    imgUrl:
      'https://jpviec.s3-ap-southeast-1.amazonaws.com/honeylab/products/royal+honey+vip+plus/royal+honey+vip+plus+10.png',
    price: 109800,
    pricePerBox: 10980,
    discount: 15000,
    id: 'royal-honey-vip-plus-10'
  }
]
